import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import * as fs from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  private getFormattedDateToInside(): string {
      const months = [
          'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
          'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE'
      ];

      const date = new Date();
      const day = date.getDate().toString().padStart(2, '0');
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      return `${day} ${month} ${year}`;
  }
  async generateExcel(data: any[]) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Productos');

    // Títulos
    const titleRow1 = worksheet.addRow(['TIENDAS QUINCHAU']);
    titleRow1.getCell(1).font = { bold: true };
    const titleRow2 = worksheet.addRow(['LISTADO DE MOTOCICLETAS']);
    const titleRow3 = worksheet.addRow([this.getFormattedDateToInside()]);

    // Merge y centrar las celdas de los títulos
    ['A', 'B', 'C', 'D'].forEach((col) => {
      titleRow1.getCell(col).alignment = { vertical: 'middle', horizontal: 'center' };
      titleRow2.getCell(col).alignment = { vertical: 'middle', horizontal: 'center' };
      titleRow3.getCell(col).alignment = { vertical: 'middle', horizontal: 'center' };
    });
    worksheet.mergeCells('A1:D1');
    worksheet.mergeCells('A2:D2');
    worksheet.mergeCells('A3:D3');

    // Encabezados
    const headerRow = worksheet.addRow(['Código', 'Descripción', 'Precio Mayor', 'Cantidad']);

    // Ordenar datos por la columna "descripción" alfabéticamente
    data.sort((a: any, b: any) => {
      if (a.description.toLowerCase() < b.description.toLowerCase()) return -1;
      if (a.description.toLowerCase() > b.description.toLowerCase()) return 1;
      return 0;
    });

    // Insertar datos
    data.forEach((item: any) => {
      worksheet.addRow([item.stockid, item.description, item.precio_final_con_impuesto_format, null]);
    });
    
    let maxContentLength = 0;
    worksheet.eachRow({ includeEmpty: false }, function(row, rowNumber) {
        let cellValue = row.getCell(2).text; // Columna B es la segunda columna
        if (cellValue && cellValue.length > maxContentLength) {
            maxContentLength = cellValue.length;
        }
    });

    // Ajusta el ancho de la columna B al maxContentLength. Puedes agregar un pequeño margen si es necesario.
    worksheet.getColumn(2).width = maxContentLength + 2; // +2 como margen
    
    // Estilo para el encabezado (puedes personalizarlo más si lo deseas)
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    this.saveAsExcelFile(buffer, `QuinChauMotos${this.getFormattedDate()}`);
  }


  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(data, fileName + '.xlsx');
  }

  // La función getFormattedDate() es la misma que la que ya tienes, solo está aquí para referencia.
  private getFormattedDate(): string {
    const months = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    const date = new Date();
    
    const year = date.getFullYear();
    const month = months[date.getMonth()];  // Obtener el mes en formato de tres letras.
    const day = String(date.getDate()).padStart(2, '0'); // Asegura que el día tenga dos dígitos.

    return `${year}${month}${day}`;
  }

}
